import React from 'react'
import {
  updateReportKeyImage,
  deleteReportKeyImage,
  addReportKeyImage,
  updateReportKeyImagesOrder,
  autoSaveUpdate,
  autoSaveRemove,
  autoSaveOrder,
  retryFailedReportKeyImages,
  autoSaveAll
} from 'report-components/lib/reducers'
import {
  getDeletedReportKeyImages,
  getItems,
  getNewId,
  getReportKeyImages,
  makeMapStateToProps
} from 'report-components/lib/selectors'
import {postFetcher, setErrors, clearErrors, getFetcher} from 'startlibs'
import {getResource} from '../lib'
import {connect} from 'react-redux'
import {KeyImages, KeyImagesPanel} from 'report-components'


const autoSaveType = {type: 'reportSignature'}
const uploadFetcher = (formData, reportUID) => postFetcher('/api/upload-key-image/' + reportUID, formData)
  .then(({resourceUID}) => ({success: {keyImage: resourceUID}}))
const emptyErrors = {}
const needsUpgrade = (user) => !(user.accountStatus === 'trialing' || (user.authorities.indexOf('KEY_IMAGES') >= 0 && ['past_due', 'trialing', 'active'].indexOf(user.accountStatus) >= 0))


export const ReportKeyImages = connect(
  makeMapStateToProps({getNewId, getItems})(
    ({getNewId}) => ({user, report, appUI}) => ({
      needsUpgrade: needsUpgrade(user),
      isHorosCloud: true,
      reportKeyImages: getReportKeyImages(report.reportKeyImages),
      deletedReportKeyImages: getDeletedReportKeyImages(report.reportKeyImages),
      newId: getNewId(report.reportKeyImages),
      reportUID: report.reportUID,
      errors: appUI.errors[addReportKeyImage] || emptyErrors
    })),
  dispatch => ({
    uploadFetcher,
    getResource,
    clearErrors: () => {
      dispatch(clearErrors(addReportKeyImage))
    },
    setErrors: (error) => {
      dispatch(setErrors(error, {actionKey: addReportKeyImage}))
    },
    update: (keyImage) => {
      const r = dispatch(updateReportKeyImage(keyImage))
      dispatch(autoSaveUpdate(keyImage, autoSaveType))
      return r
    },
    retryFailed: (props) => dispatch(retryFailedReportKeyImages(props)),
    addNew: (keyImage, index) => {
      const r = dispatch(addReportKeyImage(keyImage, {index}))
      dispatch(autoSaveUpdate(keyImage, autoSaveType))
      return r
    },
    remove: (id) => {
      const r = dispatch(deleteReportKeyImage(id))
      dispatch(autoSaveRemove(id, autoSaveType))
      return r
    },
    updateOrder: (newOrder) => {
      dispatch(updateReportKeyImagesOrder(newOrder))
      dispatch(autoSaveOrder(newOrder, autoSaveType))
    },
    deleteResource: (resourceUID) => postFetcher('/api/report-resources/' + resourceUID, '', {method: 'DELETE'})
  })
)(KeyImages)

export const ReportKeyImagesPanel = connect(({report}) => ({reportKeyImages: report.reportKeyImages}))(
  ({...props}) => <KeyImagesPanel {...props} KeyImages={(props) => <ReportKeyImages {...props}/>}/>
)

@connect(({report, user}) => ({
  reportUID: report.reportUID,
  needsUpgrade: needsUpgrade(user),
  reportKeyImages: report.reportKeyImages
}), {
  update: updateReportKeyImage,
  addNew: addReportKeyImage,
  save: autoSaveAll,
  deleteImage: deleteReportKeyImage
})
export class ReportKeyImagesLoader extends React.Component {
  componentDidMount() {
    if (!this.props.needsUpgrade) {
      this.interval = setInterval(this.fetch, 5000)
      this.fetch()
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  fetch = () => {
    const existingResourcers = Object.values(this.props.reportKeyImages).map(_ => _.resourceUID).filter(_ => _)
    getFetcher('/api/report-key-images/' + this.props.reportUID)
      .then(resourcesUID => {
          const newResources = resourcesUID
            .filter(_ => existingResourcers.indexOf(_) < 0)
            .map(missingResourceUID =>
              new Promise((res) => {
                if (Object.values(this.props.reportKeyImages).map(_ => _.resourceUID).filter(_ => _).indexOf(missingResourceUID) < 0) {
                  this.props.addNew({
                    id: missingResourceUID,
                    description: '',
                    name: '',
                    resourceUID: missingResourceUID
                  })
                  const image = document.createElement('img')
                  image.onload = () => {
                    const {naturalWidth: imageWidth, naturalHeight: imageHeight} = image
                    this.props.update({
                      id: missingResourceUID,
                      description: '',
                      name: '',
                      imageWidth,
                      imageHeight,
                      resourceUID: missingResourceUID
                    })
                    res(1)
                  }
                  image.onerror = () => {
                    res(0)
                  }
                  image.src = getResource(missingResourceUID)
                }
              })
            )
          const deletedResources = existingResourcers
            .filter(_ => resourcesUID.indexOf(_) < 0)
            .map(deleted =>
              new Promise((res) => {
                const deletedImage = Object.values(this.props.reportKeyImages)
                  .find(_ => _.resourceUID === deleted)
                if (deletedImage) {
                  this.props.deleteImage(deletedImage.id)
                    .then(_ => res(1))
                } else {
                  res(0)
                }
              })
            )
          const modifiedResources = newResources.concat(deletedResources)
          if (modifiedResources.length > 0) {
            Promise.all(modifiedResources)
              .then(() => this.props.save())
          }
        }
      )
  }

  render() { return this.props.children || null}
}


// WEBPACK FOOTER //
// ./src/javascripts/report/ReportKeyImages.jsx